<div class="ta-center b-a b-col-42 bg-col-4 p-a-2">
  @if (warning.title) {
    <p class="p2"
      [ngClass]="warning.id === warningId.discontinued ? 'col-6' : 'col-11'"
    >{{warning.title | translate}}</p>
  }
  <p class="p2 col-11">{{warning.subtitle | translate}}&nbsp;{{warning.date}}</p>
</div>